import {
  ApolloClient,
} from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloLink, from } from 'apollo-link';
import omitDeep from 'omit-deep-lodash';
import auth from '~lib/common/providers/auth';
import introspectionQueryResultData from '~lib/common/casesServiceFragmentTypes.json';

auth.renewSession();

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const authResult = JSON.parse(localStorage.getItem('vrpatients::auth::result'));

const tokenHasExpired = (authResultParam) =>
  Date.now() > new Date(authResultParam.idTokenPayload.exp * 1000);

// Redirect to login page if user is not authenticated
if (window.location.pathname.startsWith('/authoring')) {
  if (!authResult || tokenHasExpired(authResult)) {
    // window.location.replace('/auth/login');
    window.location.replace(`/auth/login?updated=${Date.now()}`); // prevent caching
  } else if (!authResult.idTokenPayload.email_verified) {
    // window.location.replace('/auth/verify');
    window.location.replace(`/auth/verify?updated=${Date.now()}`); // prevent caching
  }
  // TEMPORARILY DISABLE THIS UNTIL VRTEST ACCOUNT IS IN ORG
  // else if (!authPayload.idTokenPayload['https://vrpatients.com/org']) {
  //   window.location.replace('/auth/account/profile');
  // }
}
const cleanTypeNameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = omitDeep(operation.variables, '__typename')
  }
  return forward(operation).map((data) => {
    return data;
  });
});

const httpLink = new HttpLink({
  uri: `${process.env.VUE_APP_CASES_SERVICE_GRAPHQL_ENDPOINT}?orgGroups=${auth.getOrgGroupParams()}`,
  credentials: 'same-origin',
  headers: {
    Authorization: authResult && `Bearer ${authResult.idToken}`,
  },
});

const link = from([
  cleanTypeNameLink,
  httpLink
])

const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({ fragmentMatcher }),
  connectToDevTools: true,
});

export default apolloClient;
